const indexes = [
  { label: '明星塌房合集', count: '86期', tag: '热门', color: 'primary' },
  { label: '综艺名场面', count: '52期', tag: '新番', color: 'accent' },
  { label: '网红八卦周刊', count: '128期', tag: '连载', color: 'secondary' },
  { label: '恋情实锤档案', count: '64期', tag: '热门', color: 'primary' },
  { label: '年度大瓜回顾', count: '12期', tag: '精选', color: 'accent' },
  { label: '内娱潜规则揭秘', count: '38期', tag: '深度', color: 'secondary' },
  { label: '选秀黑幕追踪', count: '45期', tag: '连载', color: 'primary' },
  { label: '代言争议全记录', count: '29期', tag: '新番', color: 'accent' },
];

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200',
};

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-bold mb-4">
            <i className="ri-folder-line"></i>
            专题合集
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            热门专题索引
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            按主题分类整理，一站式浏览你感兴趣的吃瓜专题
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexes.map((item, i) => (
            <a
              key={i}
              href="#index"
              className={`group relative rounded-xl p-5 border transition-all duration-300 hover:shadow-md ${colorMap[item.color]}`}
            >
              <span className={`absolute top-3 right-3 text-xs px-2 py-0.5 rounded-full font-bold ${tagColorMap[item.color]}`}>
                {item.tag}
              </span>
              <h3 className="text-sm font-bold mb-3 mt-2 leading-snug">{item.label}</h3>
              <div className="flex items-center gap-2 text-xs opacity-70">
                <i className="ri-play-list-2-line"></i>
                <span>{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}